import { Route } from "react-router-dom";

import Notice from "pages/notice";
import CreateNoticePage from "pages/notice/CreateNoticePage";
import EditNoticePage from "pages/notice/EditNoticePage";

export function getNoticeRoutes() {
  return (
    <Route path="/notice">
      <Route index element={<Notice />} />
      <Route path="create" element={<CreateNoticePage />} />
      <Route path="update/:noticeId" element={<EditNoticePage />} />
    </Route>
  );
}
